import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import IMG01 from "../../images/services/cn/Public-Cloud.webp";
import IMG02 from "../../images/services/cn/Private-Cloud.webp";
import IMG03 from "../../images/services/cn/Hybrid-Cloud.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Cloud Options">
                                <h2>Cloud Options</h2>
                            </div>
                            <p>Cloud computing technology has the potential to transform the decision-making process of
                                organizations by providing a flexible and scalable infrastructure that can support
                                real-time data analysis and decision-making.</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>274B
                                        <span>Approx. market size</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>2.5M
                                        <span>Daily data production</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Public Cloud</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Private Cloud</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Hybrid Cloud</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Public Cloud</h2>
                                <p>These are secure, off-premises cloud platforms ideal for startups that wish to deploy
                                    multi-featured apps and SaaS, eliminating the need for physical storage. It offers
                                    on-demand scalability, allowing organizations to quickly and easily scale up or down
                                    their computing resources based on their needs. This means that organizations can
                                    avoid the high costs of building and maintaining their own IT infrastructure and
                                    only pay for the resources they use.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG01}
                                    effect="blur" alt="Migration" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Private Cloud</h2>
                                <p>These are scalable cloud platforms ideal for SMBs and enterprise-grade corporations
                                    that wish to utilize dedicated cloud infrastructure for real-time remote data
                                    accessibility and utilization. One of the main benefits of a private cloud is that
                                    it provides organizations with greater control and security over their data and
                                    applications. Since the private cloud is dedicated to a single organization, the
                                    organization has complete control over the configuration, security, and management
                                    of their cloud infrastructure. This enables them to customize their infrastructure
                                    to meet their specific business requirements and compliance regulations.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image">
                                <LazyLoadImage
                                    src={IMG02}
                                    effect="blur" alt="Development" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Hybrid Cloud</h2>
                                <p>These mid-level cloud platforms are ideal for business organizations with significant
                                    amounts of data and diverse end-users. Hybrid cloud offers organizations the
                                    flexibility and control of private cloud environments with the scalability and
                                    cost-effectiveness of public cloud resources. It enables organizations to optimize
                                    their computing resources based on the specific needs of their workloads, while
                                    maintaining security and control over their data and applications.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG03}
                                    effect="blur" alt="Deployment" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;